import { forwardRef } from 'react';
import { Flex } from '../Flex/index.js';
import { ListItemDefaultElement } from './constants.js';
import { ListItemWrapper, ListItemInner, FlexWrapper, StyledFlex, ListItemHr } from './styles.js';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';
import { cssShorthandPropsFilter, Spacer } from '../primitives/Spacer/index.js';

const ListItem = forwardRef(function ForwardedListItem({
  alignItems,
  as = ListItemDefaultElement,
  bottom,
  centerProps,
  children,
  density,
  hasDivider = true,
  left,
  leftProps,
  padding = 'md',
  right,
  rightProps,
  size = 'default',
  parentAs = 'li',
  parentAriaSetsize,
  parentAriaPosinset,
  ...props
}, ref) {
  const spacingHorizontalScale = padding === 'md' ? 3 : 2;
  const spacingVerticalScale = size === 'default' ? 2.5 : 2;
  const shorthandPadding = {
    pb: spacingVerticalScale,
    pl: spacingHorizontalScale,
    pr: spacingHorizontalScale,
    pt: spacingVerticalScale
  };
  const shorthandMargin = {
    ml: spacingHorizontalScale,
    mr: spacingHorizontalScale
  };
  return jsx(ListItemWrapper, {
    as: parentAs,
    ...cssShorthandPropsFilter(props),
    "aria-setsize": parentAriaSetsize,
    "aria-posinset": parentAriaPosinset,
    density: density,
    hasClickableElements: ['button', 'a'].includes(as),
    children: jsxs(ListItemInner, {
      as: as,
      ref: ref,
      ...props,
      children: [jsxs(FlexWrapper, {
        ...(!density ? shorthandPadding : {}),
        density: density,
        children: [left && jsx(Flex, {
          alignItems: alignItems,
          mr: density ? 0 : 1.5,
          ...leftProps,
          children: left
        }), jsxs(Flex, {
          justifyContent: alignItems,
          flexDirection: "column",
          ...centerProps,
          children: [children, bottom && jsx(Spacer, {
            mt: 1.5,
            children: bottom
          })]
        }), right && jsx(StyledFlex, {
          alignItems: alignItems,
          ml: "auto",
          pl: density ? 0 : 1.5,
          overflowX: "hidden",
          ...rightProps,
          children: right
        })]
      }), hasDivider && jsx(ListItemHr, {
        as: "hr",
        m: 0,
        ...(!density ? shorthandMargin : {})
      })]
    })
  });
});

export { ListItem };
